import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { TextValidator } from 'react-material-ui-form-validator';
import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { IDropdownData } from "../../_common/interface/dropdown/iDropdownData.interface";

interface IStandardExtAutocomplete extends IStandardAutocomplete {

    // isTiny?: boolean;
    // open?: boolean
    // onOpen?(event: React.SyntheticEvent): void,
    // disableCloseOnSelect?: boolean,
    // inputProps?: {},
    // isFilter?: boolean,
    // disableClearable?: boolean,
    // fullWidth?: boolean
}

export default function StandardAutoComplete(params: IStandardExtAutocomplete) {
    const [value, setValue] = useState<IDropdownData | null>();
    const [inputValue, setInputValue] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [items, setItems] = useState<Array<any>>([]);
    const [excludedIds, setExcludedIds] = useState<Array<number | string>>(
        params.excludedIds || []
    );

    useEffect(() => {
        if (params.excludedIds != excludedIds) {
            setExcludedIds(params.excludedIds ? params.excludedIds : []);
        }
    }, [params.excludedIds]);

    useEffect(() => {
        console.log("parent id update", params.parentId);
        if (params.hasParent === true) {
            if (params.parentId ? params.parentId > 0 : null) {
                fetchItems(params.parentId);
            } else if (items.length > 0) {
                setItems([]);
                changeInput(null);
            }
        } else {
            fetchItems();
        }
    }, [params.parentId]);

    useEffect(() => {
        if (items && items.length > 0) {
            changeInput(items.find((_item: any) => _item[params.valueField ?? "id"] == params.value));
        } else if (
            ((!items || items.length === 0) && value) ||
            ((!params.value || params.value === 0) && value)
        ) {
            changeInput(null);
        }
    }, [items, params.value]);

    function fetchItems(parentId?: number) {
        setLoading(true);
        return params
            .itemsLoader(parentId)
            .then(
                (json) => {
                    if (!json || json.length < 1) {
                        setItems([]);
                    } else {
                        setItems(json);
                    }
                },
                (err) => {
                    setItems([]);
                }
            )
            .finally(() => setLoading(false));
    }

    function changeInput(newValue: any) {
        newValue = newValue ? newValue : null;
        if (newValue === value) return;
        setValue(newValue);
        params.onChange?.({ target: { ...newValue, name: params.name, value: newValue?.[params.valueField ?? "id"] } }, newValue, params.name);
    }

    return (
        <Autocomplete
            fullWidth={params.fullWidth}
            open={params.open}
            onOpen={params.onOpen}
            sx={{ width: params.width ? params.width : undefined }}
            id="tags-standard"
            disableClearable={params.disableClearable ? true : false}
            options={excludedIds && excludedIds.length ? items.filter(m => m[params.valueField ?? "id"] === value || !excludedIds.some(r => r === m[params.valueField ?? "id"].toString())) : items}
            getOptionLabel={(option) => option.name}
            value={value || null}
            onChange={(event: any, newValue: any) => {
                changeInput(newValue);
            }}
            inputValue={inputValue || ''}
            onInputChange={(event: any, newInputValue: any) => {
                setInputValue(newInputValue);
            }}
            disabled={params.disabled}
            renderInput={(props) => (
                params.hasFormsValidator === false ?
                    <TextField
                        value={inputValue}
                        {...props}
                        label={`${params.label} ${params.required === true ? "*" : ""}`}
                        autoComplete="new-password"
                        name={`${params.name}`}
                        variant={params.variant || "outlined"}
                        type="text"
                        disabled={params.disabled || false}
                        InputProps={{
                            ...props.InputProps,
                            endAdornment: (
                                <>
                                    {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {props.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                    :
                    <TextValidator
                        value={inputValue}
                        {...props}
                        label={`${params.label} ${params.required === true ? "*" : ""}`}
                        autoComplete="new-password"
                        name={`${params.name}`}
                        validators={params.required === true ? ['required'] : []}
                        errorMessages={params.required === true ? ['This field is required'] : []}
                        variant={params.variant || "outlined"}
                        type="text"
                        disabled={params.disabled || false}
                        InputProps={{
                            ...props.InputProps,
                            endAdornment: (
                                <>
                                    {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {props.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
            )
            }
        />
    )

}
